var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(!!_vm.toast)?_c('v-layout',{staticClass:"toast-wrap",attrs:{"justify-center":""}},[_c('v-image',{attrs:{"src":`toast_${_vm.toast}.png`}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }